export default {
  //Welcom Screen
  Welcome: "welcome",
  Get_Started: "get_started",

  //Components
  Tap_Home_Screen: "tap_home_search",
  Seach_Text: "seach_text",
  Khud_Ke_Liye_Order_Kare: "khud_ke_liye_order_kare",
  Select_Quanity_Main_View: "select_quanity_main_view",
  Product_Details_Infinite_List: "product_details_infinite_list",

  //Auth
  Enter_Name_Field: "enter_name_field",
  Enter_Name: "enter_name",
  Otp_Input_: "otp_input_",
  Otp_Box: "otp_box",
  Enter_Otp: "enter_otp",
  Enter_Phone_Page: "enter_phone_page",
  Phone_Parent: "phone_parent",
  Enter_Phone: "enter_phone",
  Enter_Phone_Move: "enter_phone_move",
  Save_Address: "save_address",
  Date_Time_Picker: "dateTimePicker",

  //Conation
  Map_View: "map_view",
  Map: "map",
  Set_Map_Location: "set_map_location",

  // Address
  address1: "address1",
  address2: "address2",
  landmark: "landmark",
  pincode: "pincode",
  city: "city",

  //Home
  Customer_Select_Kare_Screen: "customer_select_kare_screen",
  Order_Kre_Bottom_Strip: "order_kre_bottom_strip",
  Home_Visivle: "home_visivle",
  Search_Bar: "search_bar",

  //Cart
  Confirm_Order_Screen: "confirm_order_screen",

  //Product Screen
  Product_Screen_Details: "product_screen_details",
  Add_Product_To_Cart: "add_product_to_cart",

  //Hamburger Menu options
  hamburger_drawer_view: "hamburger_drawer_view",
  hamburger_drawer: "hamburger-drawer",
  tab: "tab",
  profile_tab: "profile-tab",
  refer_tab: "refer-tab",
  profile_container: "profile-container",
  KYC_container: "KYC-container",
  leader_training_container: "leader-training-container",
  product_request_container: "product-request-container",
  about_us_container: "about-us-container",
  contact_us_container: "contact-us-container",
  webview_container: "webview-container",

  // Profile Page

  edit_profile_btn: "edit_profile_btn",
  profile_picture: "profile_picture",
  edit_name: "edit_name",
  save_profile_btn: "save_profile_btn",

  // Refer Page
  my_referals_btn: "my_referals_btn",

  // KYC page
  kyc_scroll: "kyc_scroll",
  enter_aadhar: "enter_aadhar",
  enter_PAN: "enter_PAN",

  //Request Product
  request_product_btn: "request_product_btn",
  add_product_request: "add_product_request",
  submit_product_request: "submit_product_request",

  //language selection
  lang_selection_container: "lang_selection_container",
  enter_new_lang: "enter_new_lang",

  // Privacy
  scroll_privacy_page: "scroll_privacy_page",

  // Gullak
  Gullak: "Gullak",

  // Customer
  Customers: "Customers",
  //order
  orders: "Orders",
  order_list: "order_list",
  order_no: "order_no_",
  order_scroll_view: "order_scroll_view",
  sales_view: "sales_view",
  price_detail: "price_detail",
  order_status: "order_status",
  product_no_: "product_no_",
  // profile
  change_Number: "change_Number",
  change_Address: "change_Address",
  edit_Profile: "edit_Profile",
  edit_Pic: "edit_Pic",
  name_Input: "name_Input",
  change_Number_Section: "change_Number_Section",
  save_Number: "save_Number",
  goto_Profile: "goto_Profile",
  logout: "logout",
  goto_Support: "goto_Support",
  HeaderSection: "HeaderSection",
  AddressSection: "AddressSection",
  image_Modal: "image_Modal",
  mobile_Number: "mobile_Number",
  change_profile_photo: "change_profile_photo",
  delete_Photo: "delete_Photo",
  take_photo: "take_photo",
  choose_From_Library: "choose_From_Library",
  BasicInfoProfile: "BasicInfoProfile",
  enter_Location: "enter_Location",
  Map_View: "Map_View",
  Set_Map_Location: "Set_Map_Location",
  address1: "address1",
  //TodaysCustomersScreen
  Todays_Customers: "Todays_Customers",
  Scroll_Customers: "Scroll_Customers",
  Search_Customers: "Search_Customers",
  //My Shop
  My_Shop: "My_Shop",
  Scroll_Updates: "Scroll_Updates",
  View_Customers: "View_Customers",
  View_Orders: "View_Orders",
  Click_On_Update: "Click_On_Update",
  Navigate_From_Orders_To_My_Shop: "Navigate_From_Orders_To_My_Shop",
  Navigate_From_Customers_To_My_Shop: "Navigate_From_Customers_To_My_Shop",
  //Shop Performance
  month_selected: "month_selected",
  new_selected_month: "new_selected_month",
  press_out_of_innerContainer: "press_out_of_innerContainer",
  ibutton1: "ibutton1",
  ibutton2: "ibutton2",
  //DeletePaymentModeModal
  Delete_Payment_Mode: "Delete_Payment_Mode",
  // plotline removed
};
